import queryString from "query-string";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { POST } from "@/common/apiHelpers";
import FieldComponent, { Field, linkedinValidation } from "@/common/form/FieldComponent";

const fields: Field[] = [
  {
    label: "First Name",
    name: "first_name",
    type: "text",
    validation: { required: true },
  },
  {
    label: "Last Name",
    name: "last_name",
    type: "text",
    validation: { required: true },
  },
  {
    label: "Email",
    name: "email",
    type: "email",
    validation: { required: true },
  },
  {
    label: "Vendor Name",
    name: "vendor_id",
    placeholder: "",
    type: "asyncSelect",
    validation: { required: true },
    fetchOptions: (name) => (
      POST("/public/api/v1/vendors/find", { name })
      .then(res => res?.data?.vendors ?? [])
      .then(vendors => vendors.map(({ id, name }) => ({ label: name, value: id })))
    )
  },
  {
    label: "LinkedIn Profile Url",
    name: "linkedin_profile_url",
    type: "text",
    validation: { 
      required: true,
      ...linkedinValidation
    },
  }
];

const RegisterVendor = () => {
  const navigate = useNavigate();

  const methods = useForm({
    defaultValues: {},
    mode: 'onSubmit',
    reValidateMode: 'onChange'
  });

  function handleSubmit(data: Record<string, any>) {
    const formData = {
      ...data,
      ta: false,
      regestration_attempt: true,
      entity_type: "VendorUser"
    };

    window.location.href = `/users/auth/linkedin?${queryString.stringify(formData)}`;
  }

  return (
    <>
      <h1 className="text-carnation-500 text-2xl mb-4">Join Talk</h1>
      <h2 className="text-lg mb-8">Non-TA Professional</h2>
      <div className="mb-8 max-w-2xl text-center">For the privacy and protection of all members, we require all members to verify their identity with LinkedIn. Your privacy is important to us, member contact information is never shared or sold.</div>
      <div>Already a member? <button className="text-carnation-500" onClick={() => navigate('/sign-in')}>Sign In</button></div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)} className="my-2 p-0 w-full">
          <div  className="flex flex-col flex-wrap items-center">
            {fields.map((field) => (
              <FieldComponent key={field.name} field={field} />
            ))}
          </div>
          <div className="flex flex-col items-center">
            <button type="submit" className="mt-2 px-4 py-2 text-base bg-blue-600 text-white rounded-sm">Submit and Verify with LinkedIn</button>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default RegisterVendor;
